import { render, staticRenderFns } from "./StockWeightShare.vue?vue&type=template&id=4c5b7d3a&scoped=true&"
import script from "./StockWeightShare.vue?vue&type=script&lang=js&"
export * from "./StockWeightShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5b7d3a",
  null
  
)

export default component.exports